<div (click)="changeState()" class="expand-icon">
    <mat-icon *ngIf="state">expand_more
    </mat-icon>
    <mat-icon *ngIf="!state">expand_less
    </mat-icon>
</div>
